import { render, staticRenderFns } from "./OrderScore.vue?vue&type=template&id=61d6949e"
import script from "./OrderScore.vue?vue&type=script&lang=js"
export * from "./OrderScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports